import { get } from 'vuex-pathify'

const RouteGetters = {
  computed: {
    route: get('Route')
  }
}

export default RouteGetters
